const KEY = 'kosexa_front_session_id';

/** ID estable por navegador para estimar visitantes únicos (no reemplaza login). */
export function getOrCreateKosexaFrontSessionId() {
  if (typeof localStorage === 'undefined') {
    return `anon-${Date.now()}`;
  }
  let v = (localStorage.getItem(KEY) || '').trim();
  if (!v) {
    try {
      v =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `kf-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      localStorage.setItem(KEY, v);
    } catch {
      v = `kf-${Date.now()}`;
    }
  }
  return String(v).slice(0, 64);
}
